import React from "react";
import {
  Card,
  Input,
  Headline,
  InputLabel,
  Flex,
  Select,
  Autocomplete,
  Paragraph,
} from "_styleguide";
import Footer from "../_components/Footer/Footer";
import { useLead } from "_contexts/useLead";
import { validateLocation } from "../_helpers/validation";
import { STATES } from "../_helpers/location";
import "./Location.scss";

function Location(props) {
  const { lead, updateLead, updateAddress } = useLead();
  const settings = props.settings?.settings;

  const validation = validateLocation(lead);

  return (
    <Card id="location">
      <div className="apply-form">
        <Headline>{settings.title}</Headline>
        {settings?.subtitle ? (
          <Paragraph
            opacity={0.6}
            align="left"
            size="14px"
            dangerouslySetInnerHTML={{
              __html: settings?.subtitle,
            }}
          />
        ) : null}
        <div
          className="apply-form-items"
          style={{
            marginBottom: "24px",
            marginTop: settings?.subtitle ? "0" : "24px",
          }}
        >
          <Flex vertical>
            <InputLabel htmlFor="address" {...validation.address}>
              Address *
            </InputLabel>
            <Autocomplete
              autoFocus
              value={lead.address}
              onChange={(v) => updateAddress({ address: v })}
              updateAddress={updateAddress}
              {...validation.address}
            />
            <Input
              id="address_line_two"
              value={lead.address_line_two}
              onChange={(e) => updateLead("address_line_two", e.target.value)}
              placeholder="Apt., suite, unit (optional)"
              size="medium"
              style={{ marginTop: "12px" }}
            />
          </Flex>
          <Flex vertical>
            <InputLabel htmlFor="city" {...validation.city}>
              City *
            </InputLabel>
            <Input
              id="city"
              value={lead.city}
              onChange={(e) => updateLead("city", e.target.value)}
              size="medium"
              placeholder="e.g. San Francisco"
              {...validation.city}
            />
          </Flex>
          <Flex align="flex-start" gap="12px">
            <Flex vertical flex={2}>
              <InputLabel htmlFor="state" {...validation.state}>
                State *
              </InputLabel>
              <Select
                value={lead.state}
                onChange={(val) => updateLead("state", val)}
                size="large"
                popupClassName="pp-select-dropdown"
                placeholder="e.g. California"
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                    0 ||
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                {...validation.state}
              >
                {STATES.map((s) => (
                  <Select.Option key={s.value} value={s.value}>
                    {s.label}
                  </Select.Option>
                ))}
              </Select>
            </Flex>
            <Flex vertical flex={1} style={{ maxWidth: "160px" }}>
              <InputLabel htmlFor="zip" {...validation.zip}>
                Zip *
              </InputLabel>
              <Input
                id="zip"
                value={lead.zip}
                onChange={(e) => updateLead("zip", e.target.value)}
                size="large"
                maxLength="5"
                placeholder="e.g. 94103"
                {...validation.zip}
              />
            </Flex>
          </Flex>
        </div>
      </div>
      <Footer
        next={props.settings.next}
        settings={props.settings}
        disableNext={!validation.allValid}
      />
    </Card>
  );
}

export default Location;
